import { Typography } from '@mui/material';
import { motion } from 'framer-motion';

export const MainTitle = ({ title }) => {
	return (
		<motion.span
			initial={{ opacity: 0, translateY: 550 }}
			animate={{ opacity: 1, translateY: 0 }}
			transition={{ type: 'spring', stiffness: 150, damping: 30 }}>
			<Typography
				variant='h3'
				sx={{
					fontFamily: 'Itim, handwriting',
					fontWeight: 600,
					fontSize: { xs: '2rem', md: '2.25rem' },
					lineHeight: 1.15
				}}>
				{title}
			</Typography>
		</motion.span>
	);
};
